var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassVis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 0.675781C4.6665 0.675781 1.81984 2.74911 0.666504 5.67578C1.81984 8.60245 4.6665 10.6758 7.99984 10.6758C11.3365 10.6758 14.1798 8.60245 15.3332 5.67578C14.1798 2.74911 11.3365 0.675781 7.99984 0.675781ZM7.99984 9.00912C6.15984 9.00912 4.6665 7.51578 4.6665 5.67578C4.6665 3.83578 6.15984 2.34245 7.99984 2.34245C9.83984 2.34245 11.3332 3.83578 11.3332 5.67578C11.3332 7.51578 9.83984 9.00912 7.99984 9.00912ZM7.99984 3.67578C6.8965 3.67578 5.99984 4.57245 5.99984 5.67578C5.99984 6.77911 6.8965 7.67578 7.99984 7.67578C9.10317 7.67578 9.99984 6.77911 9.99984 5.67578C9.99984 4.57245 9.10317 3.67578 7.99984 3.67578Z",
    fill: "#2D49FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassVis);
export default __webpack_public_path__ + "static/media/PassVis.0f46e354.svg";
export { ForwardRef as ReactComponent };